<template>
    <ActionModal class="TooMuchRequestsModal" title="" :width="'800'" @close="close">
        <template #default>
            <CText>
                {{ text }}
            </CText>
            <CText
                >Ak potrebuješ pomoc, ozvi sa nám na <a :href="`mailTo:${email}`"> {{ email }} </a>.</CText
            >
            <CText>Ďakujeme, že s nami robíš GROWNi lepšie. </CText>
        </template>

        <template #footer>
            <CButton size="large" @click.prevent="close"> Zatvoriť </CButton>
        </template>
    </ActionModal>
</template>

<script setup lang="ts">
const props = defineProps({
    text: {
        type: String,
        default: ''
    },
    email: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['close'])

const close = () => {
    emit('close')
}
</script>
